import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { NumberParam, StringParam, useQueryParams, withDefault } from 'use-query-params';
import { Box, Button, Grid, MenuItem, Stack, TextField } from '@mui/material';

import { useGetNomenclatureGroupIntervalsQuery } from '@/services';
import { AppBar, Empty, Error, Loader } from '@/components';
import { OrderDirections, ORDER_DIRECTIONS } from '@/utils/order-directions';

import { NomenclatureGroupIntervalsTable, CreateNomenclatureGroupInterval } from './components';

const NomenclatureGroupIntervalsPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();

  const [{ order_direction, page }, setQuery] = useQueryParams({
    page: withDefault(NumberParam, 1),
    order_direction: withDefault(StringParam, OrderDirections.DESC),
  });

  const [createModalOpened, setOpenedCreateModal] = useState(false);

  const {
    data: nomenclatureGroupIntervals,
    isLoading,
    isSuccess,
    isError,
  } = useGetNomenclatureGroupIntervalsQuery({
    params: { nomenclature_group_id: id, order_direction, page, order_by: 'id' },
  });

  return (
    <>
      <AppBar title="Интервалы номенклатурных групп" />

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3}>
            <Box sx={{ width: 310 }}>
              <TextField
                select
                value={order_direction}
                label="Сортировать по"
                disabled={isLoading}
                onChange={(event) => setQuery({ order_direction: event.target.value })}
                variant="filled"
                fullWidth
                size="small"
              >
                {ORDER_DIRECTIONS.map(({ value, label }) => (
                  <MenuItem key={value} value={value}>
                    {label}
                  </MenuItem>
                ))}
              </TextField>
            </Box>

            <Box sx={{ width: 210 }}>
              <Button
                disabled={isLoading}
                onClick={() => setOpenedCreateModal(true)}
                size="large"
                variant="contained"
                fullWidth
              >
                Добавить
              </Button>
            </Box>
          </Stack>
        </Grid>

        <Grid item lg={8} md={10} xs={12}>
          {isLoading ? (
            <Loader />
          ) : isError ? (
            <Error text="Произошла ошибка с загрузкой интервалов! Пожалуйста, попробуйте позже" />
          ) : isSuccess && Boolean(nomenclatureGroupIntervals?.data?.length) ? (
            <NomenclatureGroupIntervalsTable
              list={nomenclatureGroupIntervals}
              page={page}
              onChangePage={(page) => setQuery({ page })}
            />
          ) : (
            <Empty text="Интервалы номенклатурной группы отсутствуют" />
          )}
        </Grid>
      </Grid>

      <CreateNomenclatureGroupInterval onClose={() => setOpenedCreateModal(false)} open={createModalOpened} />
    </>
  );
};

export default NomenclatureGroupIntervalsPage;
